// import Micromodal and modules
import Micromodal from 'micromodal';

export default Micromodal;
